[
  {
    "url": "/_next/static/hJ0UrTl1wFIWTSfX4TtN9/_ssgManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/hJ0UrTl1wFIWTSfX4TtN9/_clientMiddlewareManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/hJ0UrTl1wFIWTSfX4TtN9/_buildManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-2c3mg3r-05n1w.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/44xfh_a5quoi3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3pcx0fv22_-d5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3kqfaqo3-gq08.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3jg77vt2i1yjm.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3fl3i53k65c0b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3drugvs4a9zm2.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3cxfp-wn-6yw4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3cfn99dbrcvvp.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/39twaixa1k8tm.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/37y5fb28r-hgd.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/36-beue468n2b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/31_fr7zrzsd7l.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2x0xnae7c6-9j.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2thi7pm4yxdct.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2t3eh6bzbj13k.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2o7ql_tsn7zn7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2nzc8yel-_cot.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2kl-2du9ssb5o.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2khxl0v1q4i6n.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2hgtfdn52e_x6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/29y_wibcanj6h.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/26eglzs6vmne9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/24metw6k8gc59.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/242e-o4053wd-.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/237amqqvmjmg6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1tdpoz6qqsdf3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1lbqhn1vvm-r0.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1igk5lpaeuml_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1i-5jcz1s19t6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1eyi7p-ivutrv.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1d5pnylyf9_-3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1cbgt0j22b-ze.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1b00i5rl6sw8k.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/17rse1xbmkzua.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/16xkec5owyzme.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/12f17doq-i2ll.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1-is4g856jcfs.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0wecrcqw3ab76.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0umf92h1sb77c.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0rdobg-a42joi.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0r-yur70-ku2o.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0qx7c8zq3r_f4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0qupx9nlcihfc.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0oxyyupfnawt3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0mcz23ihktf3d.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0lt3bqi35vtci.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0iy0vtpanx_7t.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0etpu0ihigcy_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0cz1d0mv5g_q7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/08s9woutnx6yt.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/07ic6bny-d8yi.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0--b93s-l86p0.js",
    "revision": null
  },
  {
    "url": "/sw.js",
    "revision": "92db6b3553d58d0a724ba4fae4dc10f8"
  },
  {
    "url": "/robots.txt",
    "revision": "982de462611c84f8a29b1d713c010afb"
  },
  {
    "url": "/print.css",
    "revision": "b228237dcd4130c5481158bb2beaad1f"
  },
  {
    "url": "/manifest.json",
    "revision": "e900ec70e1dda4a79f7b65f84617b925"
  },
  {
    "url": "/favicon.ico",
    "revision": "697f85b459afa38eb0aee3361fc5b03d"
  },
  {
    "url": "/images/share.jpg",
    "revision": "3b9048e5edb9833008f8f078e2e602ec"
  },
  {
    "url": "/images/placeholder.jpg",
    "revision": "23df7201bc81851266549e28042b6418"
  },
  {
    "url": "/images/nuts-bg.svg",
    "revision": "1680f9cc55e92ada0173b619c2f7c76a"
  },
  {
    "url": "/images/half-nuts-bg.svg",
    "revision": "03480c9a05feed19f94df7f31539b899"
  },
  {
    "url": "/images/contact-banner.jpg",
    "revision": "4abc261354f5069c80c4e3c34fd7d24e"
  },
  {
    "url": "/images/catalogue.png",
    "revision": "68c443a57a966a7f651e4da989c3e9a0"
  },
  {
    "url": "/images/about-banner.jpg",
    "revision": "72e048bf804b949822faeb797f223c62"
  },
  {
    "url": "/icons/maskable-x512.png",
    "revision": "77184633e6b5c82bf66969ada5abafa9"
  },
  {
    "url": "/icons/maskable-x384.png",
    "revision": "097f12b2b86d3dc48285fa0c9d7e5965"
  },
  {
    "url": "/icons/maskable-x192.png",
    "revision": "09aa5e2b9f4a11a4dc95a46874d70094"
  },
  {
    "url": "/icons/maskable-x128.png",
    "revision": "04a2431787fd14aa73c56f25434c81d6"
  },
  {
    "url": "/icons/icon-x512.png",
    "revision": "77184633e6b5c82bf66969ada5abafa9"
  },
  {
    "url": "/icons/icon-x384.png",
    "revision": "097f12b2b86d3dc48285fa0c9d7e5965"
  },
  {
    "url": "/icons/icon-x192.png",
    "revision": "09aa5e2b9f4a11a4dc95a46874d70094"
  },
  {
    "url": "/icons/icon-x128.png",
    "revision": "04a2431787fd14aa73c56f25434c81d6"
  },
  {
    "url": "/icons/favicon-32x32.png",
    "revision": "23271c476f9602d6285ea5aff7b6d256"
  },
  {
    "url": "/icons/favicon-16x16.png",
    "revision": "697f85b459afa38eb0aee3361fc5b03d"
  },
  {
    "url": "/icons/apple-touch-icon.png",
    "revision": "a300857ad4ba642160e37c7e26f3ff4a"
  }
]